<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="700"
  >
      <v-card
        class="rounded-card"
      >
        <v-card-title>
          処理結果
        </v-card-title>
        <v-divider />
        <v-card-text>
          <div
            v-for="error of errorMessages"
            :key="error.manifest_no"
          >
            <ul>
              <li
                v-for="error_message of error.error_messages"
                :key="error_message"
              >
                {{ error_message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'BulkRegistErrorDialog',
  components: {},
  mixins: [],
  props: {
    errorMessages: {
      type: Array,
      default: () => []
    },
    enableDialog: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
    enableDialog (newValue) {
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    /**
     * 初期値を取得/設定
     */
    setVariable () {
    },
    /**
     * 閉じるボタン クリックイベント
     * @description 呼び出し元で設定されたコールバックを呼び出します.
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
  }

}
</script>
